export default {
    drawerTitle: 'Display Settings',
    view: {
        title: 'View',
        small: 'Small',
        medium: 'Medium',
        large: 'Large',
    },
    filter: {
        title: 'Filter',
    },
    order: {
        title: 'Order',
        camScore: 'Popularity',
        numberOfPeople: 'Most Viewers',
        newestLoggedOn: 'Newest Online',
        newestSignedUp: 'Newest Models',
        alphabetical: 'Name A–Z',
        missMFC: 'Miss MFC Rank',
        random: 'Random',
        sortOptions: 'Sort Options',
        groupByShowType: 'Group by Show Type',
        groupByShowTypeHint: 'Separates Public Chat and Token Shows',
    },
    pinnedToTop: {
        title: 'Pinned to top',
        missMFCTop3: 'Miss MFC Top 3',
    },
    extras: {
        title: 'Extras',
        floatingPlayer: 'Keep a mini video player pinned while browsing',
        floatingPlayerInfo:
            "This setting refers to the mini video player that pops up at the bottom of the screen when you navigate away from the chat room without explicitly closing the room. It's a helpful indication that you are still a participant in the room, as well as a shortcut to bring you back to the room.",
        avatarScrollPreview: 'Enable previews on scroll in Avatar display',
        avatarScrollPreviewInfo:
            "This is a mobile device (phone) feature only and it refers to the default (Avatar) display grid on the home page. The grid will display the model's video in the relevant tile as you scroll.",
    },
    links: {
        accountSettings: 'Account settings',
        addToHome: 'Add MFC to your homescreen',
    },
    chat: {
        title: 'Chat Settings',
        fontSize: 'Chat Font Size',
        fontSizeLabel: 'Font size',
        fontSizes: {
            xSmall: 'Smallest',
            small: 'Small',
            normal: 'Normal',
            large: 'Large',
            xLarge: 'Largest',
        },
        options: {
            hideVideo: 'Hide Video',
            hideChat: 'Hide Chat Room',
            hideTopic: 'Hide Room Topic',
            muteBasics: 'Hide Chat of Basics',
            muteGuests: 'Hide Chat of Guests',
            highlightFriends: 'Highlight Chat of Friends',
            highlightHover: 'Highlight Chat with Mouse-Over',
            highlightLatest: 'Highlight Latest User Messages',
            hideImages: 'Do not display Chat Images',
            noEmotePreview: 'Do not auto preview Emotes',
        },
    },
    sounds: {
        pmTitle: 'Private Message Sounds',
        pmTypeTitle: 'Private Message Sound Type',
        alertsTitle: 'Audible Alerts',
        soundNumber: 'Sound #',
        allMessages: 'On ALL messages sent AND received',
        receivedOnly: 'On ALL received messages only',
        firstOnly: 'ONLY 1st message received per session',
        off: 'TURN OFF private message sounds',
        friendLogin: 'Hear a sound when non-model friends log in',
        modelFriendLogin: 'Hear a sound when model friends log in',
        bookmarkedFriendLogin: 'Hear a sound when a Bookmarked Friend logs in',
        modelEntersPrivate:
            'Hear a sound when a model friend enters a private or group session',
        webcamWatcher: 'Hear a sound when someone watches your webcam',
    },
    alerts: {
        title: 'Alerts Settings',
        badges: 'Badges',
        tooltips: 'Tooltips',
    },
    chatFontColor: {
        current: 'Current',
        title: 'Chat Font Color',
        listTitle: 'You can change the color of your chat:',
        pickerTitle: 'Use this selector to find a more unique color:',
        premiumMembers: 'Premium members have access to multiple font colors.',
        premiumMembers250RP:
            'When you accumulate 250 Reward Points, unlimited chat color options will be available.',
        preview: 'Preview',
        updated: 'Chat Color updated!',
        darkModeNote: 'We adjust colors for dark mode.',
        displayedLikeThisIn: 'will be displayed like this in',
        lightMode: 'light mode',
        darkMode: 'dark mode',
    },
    displayType: {
        title: 'Display Type',
        avatars: 'Avatar',
        previews: 'Preview',
        text: 'Text',
        detailed: 'Details',
        list: 'List',
        twoColumns: '2 Columns',
        overlayAvatarOnPreview: 'Overlay Avatar on Preview',
    },
    extraOptions: {
        dialogText:
            'The mini video player will close, and it will no longer pop up when you leave a room without closing it.',
        dialogReenableText:
            'To turn it back on, open Display Settings from the Display Switcher or My Account, then turn it on under Extras.',
        dialogTitle: 'Hide Mini Video Player',
    },
    loungeTimer: {
        title: 'Timer',
    },
    loungeTabs: {
        modelFeed: 'Model Feed',
        recent: 'Recent',
        friendsBookmarks: 'Friends / Bookmarks',
    },
    loungeOptions: {
        title: 'Lounge Options',
        autoClick: 'Auto Click Previews',
        noPreviews: 'Hide Lounge Previews',
    },
    previewAnimationRate: {
        title: 'Animation Speed',
        off: 'Off',
        static: 'Slowest',
        slow: 'Slow',
        medium: 'Medium',
        fast: 'Fast',
    },
    gridDensity: {
        title: 'Display Size',
    },
    gridUpdateRate: {
        title: 'Grid Refresh Rate',
        quarterMinute: '15 sec',
        halfMinute: '30 sec',
        minute: '1 min',
        twoMinutes: '2 min',
        fiveMinutes: '5 min',
        tenMinutes: '10 min',
    },
    regions: {
        title: 'Regions',
        all: 'All',
        none: 'None',
        invert: 'Invert',
        showOnly: 'Only',
    },
    pinToTop: {
        priorWinnersTooltip: 'Models that finished top 3 Miss MFC in any month',
        friends: 'Friends',
        bookmarks: 'Bookmarks',
        modelsYouMayLike: 'Models You May Like',
        popular: 'Most Popular',
        trending: 'Trending',
        recentlyVisited: 'Recently Visited',
        missMFC: 'Top Miss MFC Ranks',
        newModels: 'New Models',
        modelsWithNotes: 'Models with Notes',
        groupShows: 'Group Shows',
        privateShows: 'Private Shows',
        customizedPinnedModelsTooltip:
            'Some settings may take up to 60 seconds to be reflected on the home screen.',
    },
    show: {
        title: 'Show',
        custom: 'All Models',
        new: 'New Models',
        publicChat: 'Models in Public Chat',
        friendsAndNew: 'Friends & New Models',
        friendsAndBookmarks: 'Friends & Bookmarks',
        friends: 'Only Friends',
    },
    pushNotifications: {
        title: 'Push Notifications',
        typesTitle: 'Model Broadcasting Notifications',
        friends: 'Friends',
        bookmarks: 'Bookmarks',
        bookmarkedFriends: 'Only Bookmarked Friends',
        pmTitle: 'Private Messages',
        pm: 'Private Messages',
        modelNotifications: 'Model Notifications',
        manageModels:
            'Manage which models notify you from Model Notifications.',
    },
    modelNotificationSettings: {
        browserSetup: 'Browser Notification Setup',
        receiveTypes: 'Receive Types of Notifications for',
        email: 'Email to use for Notifications',
        otherOptions: 'Other Options',
        addModel: 'Add Model Notification for',
        premiumFeature: 'Premium feature',
        tempDisable: {
            email: 'Temporarily disable E-Mail notifications',
            push: 'Temporarily disable Browser notifications',
        },
    },
    messagePrivacy: {
        title: 'Accept private messages from',
    },
    inlinePM: {
        title: 'Display private messages in chat room',
        description:
            'Private messages you send and receive will be displayed alongside chat room text. Other users do not see this chat.',
        onlyChatCommand: 'Only when using the /w or /pm chat command',
        onlyRoomModel: 'Only from the model',
        all: 'All PMs',
    },
    inChatQuickbuy: {
        title: 'QuickBuy in Chat',
        description:
            'Show the QuickBuy menu in chat when your token balance runs out.',
        yes: 'Yes',
        no: 'No',
    },
    tokenPrivacy: {
        title: 'Allow models to see my token balance',
        description:
            "Token approximations will show: 'Low' (1-199 tokens), 'Medium' (200-899 tokens), or 'High' (900+ tokens) instead of the actual token amount.",
        hide: 'No',
        approximation: 'Approximation (Low/Medium/High)',
        show: 'Yes',
    },
    pointsPrivacy: {
        title: 'Allow models to see my Reward Points',
        hide: 'No',
        approximation: 'Approximation (Low/Medium/High)',
        show: 'Yes',
    },
    truePrivate: {
        title: 'TruePrivate',
        description:
            'Prohibit other members from having the option to spy on your private shows. A normal private show costs 60 tokens per minute, but with TruePrivate the cost is 80 tokens per minute.',
        off: 'Disabled',
        on: 'Enabled',
    },
    privateGallery: {
        title: 'Allow my private sessions to be included in the Private Gallery',
        off: 'Yes',
        on: 'No',
    },
    administrativeEmails: {
        title: 'Receive administrative emails (website updates, promotions, news)',
        off: 'No',
        on: 'Yes',
    },
    purchaseConfirmationEmails: {
        title: 'Receive token purchase confirmation emails',
        off: 'No',
        on: 'Yes',
    },
    reset: {
        label: 'Reset to Defaults',
    },
    displayToolbar: {
        display: 'Display',
        open: 'Quick display options',
        close: 'Close display options',
        allSettings: 'All Display Settings ›',
        title: 'Settings',
        animation: 'Animation',
    },
    chatOptions: {
        videoOptions: {
            title: 'Video Options',
        },
    },
}
